import {createSlice, current} from '@reduxjs/toolkit';
import {getUserLimitFailure, getUserLimitRequest, getUserLimitSuccess} from 'src/openapi/admin/apis/UserSearchLimitApi';

import type {UserTotalLimit} from 'src/openapi/admin/models/UserTotalLimit';
import type {AppState} from 'src/store/typedef';
import type {ServerResponse} from 'src/typedef';

type InitialState = {
    loading: boolean,
    cache: Record<string, ServerResponse<UserTotalLimit>>,
};

const initialState: InitialState = {
    loading: false,
    cache: {},
};

export const limitDetailsSlice = createSlice({
    name: 'usersGroupsSearchResultLimitDetails',
    initialState,
    reducers: {
        clearData: state => {
            state.loading = false;
            state.cache = {};
        },
    },
    extraReducers: builder => builder
        .addCase(getUserLimitRequest, state => {
            state.loading = true;
        })
        .addCase(getUserLimitSuccess, (state, action) => {
            const {cache} = current(state);
            const key = `${action.payload.meta.userId}-${action.payload.meta.limitTotalColumn}`;

            state.cache = {
                ...cache,
                [key]: {data: action.payload.data},
            };
            state.loading = false;
        })
        .addCase(getUserLimitFailure, (state, action) => {
            const {cache} = current(state);
            const key = `${action.payload.meta.userId}-${action.payload.meta.limitTotalColumn}`;

            state.cache = {
                ...cache,
                [key]: {error: action.payload.data},
            };
            state.loading = false;
        }),
});

export const limitDetailsActions = limitDetailsSlice.actions;

export const limitDetailsSelector = (state: AppState, userId: number, columnId: string) =>
    state.accountPage.tabs.usersAndGroups.userSearchResult.limitDetails.cache[`${userId}-${columnId}`];
